


























































































import {
  Prop,
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import DocumentSignatureDynamicTemplate from "@/shared/components/DocumentSignatureDynamicTemplate.vue";
import {
  FetchState,
  DocumentSaveSignatureRequest
} from "@/shared/types";
import * as routes from "@/employee/route-names";
import moment from "moment";
import * as _ from "lodash";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";

const initialState: DocumentSaveSignatureRequest = {
  documentKey: null,
  captureName: null,
  metaData: []
};

@Component({
  components: {
    GenericLoadingSpinner,
    DocumentSignatureDynamicTemplate
  }
})
export default class DocumentSignature extends Vue {
  signingDocument = useSigningDocumentStore();

  @Prop()
  documentKey: string;

  @Prop()
  data: object;

  @Prop()
  hideHeader: boolean;

  @Prop()
  enableCheckbox: boolean;

  routes = routes;
  moment = moment;
  isSubmitting = false;
  isReachedBottom = false;
  formModel: DocumentSaveSignatureRequest = { ...initialState };
  dynamicTemplateData = {};
  isSignatureChecked = false;

  mounted () {
    if (this.documentKey) this.signingDocument.getSignature(this.documentKey);
  }

  @Watch("signingDocument.signatureFetchState", { deep: true })
  onSignatureFetchStateChange () {
    if (this.signingDocument.signatureFetchState === FetchState.Loaded) {
      if (this.signingDocument.isSigned) {
        this.signingDocument.get({ documentKey: this.key, version: this.signingDocument.signature.documentVersion });
        this.$emit("signed", this.signingDocument.signature.captureName);
        for (const item of this.signingDocument.signature.metaData) {
          this.dynamicTemplateData[item.key] = item.value;
        }
      } else {
        this.signingDocument.getDocumentLatestVersion(this.key);
        this.dynamicTemplateData = _.cloneDeep(this.data);
      }
    }
  }

  get isSubmitEnabled (): boolean {
    return (
        !this.isSubmitting &&
        this.signingDocument.isDocumentLoaded &&
        this.isReachedBottom
    );
  }

  get key () {
    return this.documentKey ? this.documentKey : this.signingDocument.currentDocument.documentKey;
  }

  onSubmit () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }
      if (this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;
      this.formModel.documentKey = this.key;
      for (const property in this.dynamicTemplateData) {
        this.formModel.metaData.push({ key: property, value: this.dynamicTemplateData[property] });
      }
      this.formModel.metaData = [...new Map(this.formModel.metaData.map(v => [v.key, v])).values()];
      this.signingDocument.saveSignature(this.formModel).then(() => {
        this.signingDocument.getSignature(this.key);
        this.isSubmitting = false;
        this.$emit("signed", this.formModel.captureName);
      });
    });
  }

  onScroll (e) {
    const { scrollTop, offsetHeight, scrollHeight } = e.target;
    if ((scrollTop + offsetHeight) >= (scrollHeight - 1)) {
      this.isReachedBottom = true;
    }
  }

}
